webpackJsonp([106099220743852],{

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anchor = __webpack_require__(41);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _ApiDocs = __webpack_require__(61);
	
	var _ApiDocs2 = _interopRequireDefault(_ApiDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'LocaleUtils API' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Set of functions used internally to localize the component.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      ' ',
	      'In some cases, you may want to implement your own ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'LocaleUtils'
	      ),
	      ', or override some of its functions (see:',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/docs/localization' },
	        'Localization'
	      ),
	      '). For example, this code renders the month\u2019s title as ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'M/YYYY'
	      ),
	      ' instead of the default:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import DayPicker, { LocaleUtils } from "react-day-picker";\n\nfunction formatMonthTitle(d, locale) {\n return `${d.getMonth() + 1}/${d.getFullYear()}`\n}\n\n<DayPicker localeUtils={ { ...LocaleUtils, formatMonthTitle } } />\n'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _ApiDocs2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Functions'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'formatDay' }),
	        'formatDay ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, locale: string) \u21D2 string'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Format the string used as aria-label for the given ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'formatMonthTitle' }),
	        'formatMonthTitle ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(month: Date, locale: string) \u21D2 string'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the string used to format the month\u2019s title for the given',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'month'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'formatWeekdayLong' }),
	        'formatWeekdayLong ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(i: number, locale: string) \u21D2 string'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the string used to render the weekday\u2019s long name (starting from',
	        _react2.default.createElement(
	          'code',
	          null,
	          '0'
	        ),
	        ' as Sunday).'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'formatWeekdayShort' }),
	        'formatWeekdayShort ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(i: number, locale: string) \u21D2 string'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the string used to render the weekday\u2019s short name, e.g.',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'Mo'
	        ),
	        ' for',
	        _react2.default.createElement(
	          'i',
	          null,
	          'Monday'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'getFirstDayOfWeek' }),
	        'getFirstDayOfWeek ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(locale: string) \u21D2 number'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the first day of the week for the given locale (where',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '0'
	        ),
	        'is Sunday).'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'getMonths' }),
	        'getMonths ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(locale: string) \u21D2 number'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return the twelve months for the given locale (full name, e.g.',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'January'
	        ),
	        ').'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-api-locale-utils-js-b772e211c8af8b9931b7.js